import React, { FC, ReactNode, useMemo } from "react";
import classNames from "classnames";

import { Button } from "../Button";
import Icon from "../Icon";
import { SimpleAction } from "../../../types/GlobalTypes";

type Props = {
  size?: number;
  status?: "pending" | "done" | "error";
  children?: ReactNode;
  action?: SimpleAction;
};

const statusBackgroundColor = {
  pending: "bg-slate-500",
  done: "bg-green-500",
  error: "bg-orange-500",
};

const statusIcon = {
  pending: undefined,
  done: "Checkmark",
  error: "Close",
};

const calcSizes = (size: number) => ({
  iconSize: size * 0.75,
  wrapperSize: `${size}px`,
});

export const StatusOnboarding: FC<Props> = ({
  size = 32,
  status = "pending",
  children,
  action,
}) => {
  const { iconSize, wrapperSize } = useMemo(() => calcSizes(size), [size]);
  const statusBgColor = statusBackgroundColor[status];
  const iconName = statusIcon[status];

  return (
    <div className="flex justify-between gap-1">
      <div className="flex-1 flex gap-4 items-center">
        <span
          className={classNames(
            "p-1 rounded-full relative block",
            statusBgColor
          )}
          style={{
            minHeight: wrapperSize,
            minWidth: wrapperSize,
          }}
        >
          {iconName && (
            <Icon
              icon={iconName}
              size={iconSize}
              className="text-white"
              disableFill
            />
          )}
        </span>

        {children && <span className="font-manrope text-base">{children}</span>}
      </div>

      {status === "pending" && (
        <Button
          variant={Button.variant.TERTIARY}
          onClick={action?.onClick}
          className="!px-1 !py-0 !h-auto"
        >
          {action?.label}
        </Button>
      )}
    </div>
  );
};
